// extracted by mini-css-extract-plugin
module.exports = {"container":"InfiniteStories_container__W0xdi","loadMore":"InfiniteStories_loadMore__dIX_B"};